module.exports = __webpack_public_path__ + "img/img5.848dcc52.svg";